module.exports = __webpack_public_path__ + "img/btn_normal_pay.fc017545.png";